<template>
  <div>
    <v-container class="container not-printable" fluid>
      <v-card elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="6">
            <h3>التقارير</h3>
          </v-col>
          <v-col cols="6" align="right" v-if="$store.state.userData.roleId != 61">
            <v-row>
              <v-col cols="5">
                <v-autocomplete
                  hide-details
                  v-model="employeeId"
                  outlined
                  label="الموظف"
                  dense
                  item-text="employeeName"
                  item-value="idEmployee"
                  :items="employees"
                  item-color="accent"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-dialog ref="dialog" v-model="datePickerSearchModel" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field dense hide-details v-model="dateRangeText" label="اختر التاريخ من - الى" readonly outlined v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="dates" scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datePickerSearchModel = false"> الغاء </v-btn>
                    <v-btn text color="primary" @click="getDates"> موافق </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="1">
                <v-btn icon @click="searchData">
                  <v-icon color="primary" size="30">mdi-file-search-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container not-printable" fluid v-if="ShowDetails">
      <v-card elevation="6">
        <v-data-table :headers="headers" :items="payments" :items-per-page="15" item-key="idCoursePay" class="table-content">
          <template v-slot:[`item.index`]="{ index }">
            <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <p style="padding: 0 3px">
              {{
                item.price.toLocaleString("en-US")
              }}
            </p>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      employees: [],
      employeeId: null,
      datePickerSearchModel: false,
      dates: [],
      payments: [],
      headers: [
        { text: "التسلسل", value: "index" },
        { text: "اسم الطالب", value: "studentName" },
        { text: "اسم الكورس", value: "courseName" },
        { text: "تاريخ القبض", value: "dateFormat" },
        { text: "السعر", value: "price" },
      ],
      ShowDetails: false,
    };
  },
  created() {
    this.initialization();
  },
  methods: {
    initialization() {
      let self = this;
      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrlFees}/coursePaysEmployees`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((employees) => {
            console.log(employees.data);
            self.employees = employees.data;
          })
        )
        .catch((e) => console.log(e));
    },
    setDate(isoDate) {
      const date = new Date(isoDate);
      // const formattedDate = date.toISOString().slice(0, 19).replace("T", " ");
      const formattedDate = date.toLocaleDateString().split("/");

      return `${formattedDate[2]}-${formattedDate[0] < 10 ? "0" + formattedDate[0] : formattedDate[0]}-${formattedDate[1] < 10 ? "0" + formattedDate[1] : formattedDate[1]}`;
    },
    searchData() {
      let self = this;
      if (self.dates.length > 0 || self.employeeId) {
        let query = "";

        if (self.employeeId) {
          query += `&employeeId=${self.employeeId}`;
        }
        self.$http
          .get(`${self.$store.state.apiUrlFees}/searchCoursePays?dates=${JSON.stringify(self.dates)}${query}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            console.log(res.data);
            self.ShowDetails = true;
            self.payments = res.data;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    getDates() {
      this.datePickerSearchModel = false;
    },
  },
  computed: {
    dateRangeText() {
      return this.dates.length > 0 ? this.dates.join(" - ") : "تاريخ من - الى";
    },
  },
};
</script>

<style lang="scss" scoped></style>
